import { render } from "./TransactionTable.vue?vue&type=template&id=ed82ef26"
import script from "./TransactionTable.vue?vue&type=script&lang=js"
export * from "./TransactionTable.vue?vue&type=script&lang=js"
script.render = render

export default script